import Card from "components/card/Card";
import React, { useEffect, useState } from "react";
import useAxios from "axios-hooks";
import { Flex, Text, Box } from "@chakra-ui/react";
import PropertyOwnerDetails from "../components/PropertyOwnerDetails";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { updateChargingPointDrawerState } from "atoms/updateChargingPointDrawerState";
import UpdateChargePointDrawer from "../components/UpdateChargePointDrawer";
import ConnectorTabs from "../tabs/ConnectorTabs";
import { toastState } from "atoms/toastState";
import { loggedInUserState } from "atoms/loggedInUserState";
import { accessLevels } from "utils/accessLevels";
import logger from "infra/logger";
import { onlyAdmins } from "utils/accessLevels";
import RoleBasedRender from "components/wrappers/roleBasedRender";

import Firmware from "../components/Firmware";
import QrCode from "../components/QrCode";

import "../../../../assets/css/chargePoints.css";
import restart from "../../../../assets/img/chargePointsTab/restart.png";
import edit from "../../../../assets/img/chargePointsTab/edit.png";
import cache from "../../../../assets/img/chargePointsTab/white_cache.png";
import ChargerConfig from "../components/ChargerConfig";
import { onlyUAdmins } from "utils/accessLevels";

const ChargePoint = ({ data, getChargePoints }) => {
  const [chargePointStatus, setChargePointStatus] = useState("");
  const loggedInUser = useRecoilValue(loggedInUserState);
  const role = loggedInUser?.role;
  const canEdit = accessLevels[role]?.accessLevel <= 2;
  const updatedAt = new Date(data.UpdatedAt);
  const setToast = useSetRecoilState(toastState);
  const [updateDrawerState, setUpdateDrawerState] = useRecoilState(
    updateChargingPointDrawerState,
  );
  const [{ data: resetData, loading, error }, execute] = useAxios(
    { method: "POST", url: "/api/ocpp16/resetCharger" },
    { manual: true },
  );

  const [{ data: cData, loading: cLoading, error: cError }, executeClearCache] =
    useAxios(
      { method: "POST", url: "/api/ocpp16/clearCache" },
      { manual: true },
    );
  const [
    { data: statusData, loading: statusLoading, error: statusError },
    getChargePointStatus,
  ] = useAxios(
    { method: "GET", url: `/api/stations/${data?.Id}` },
    { manual: true },
  );
  const editHandler = (id) => {
    setUpdateDrawerState({ isOpen: true, activeId: id });
  };

  const updateHandler = () => {
    setUpdateDrawerState(null);
    getChargePoints();
  };

  const getChargePointDetails = async () => {
    try {
      const response = await getChargePointStatus();
      setChargePointStatus(response?.data?.data?.Status);
    } catch (error) {
      logger.log(error);
    }
  };
  const cmsEnv = process.env.REACT_APP_CMS_ENV;
  const subDomain = window.location.hostname.split(".")[0];
  const resetHandler = async () => {
    let body = {};
    body["Type"] = "Hard";
    body["StationId"] = data?.StationId;
    try {
      const response = await execute({ data: body });
      setToast({
        isOpen: true,
        title: "ChargePoint Restarted successfully",
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      setToast({
        isOpen: true,
        title: "Error occured when restarting ChargePoint",
        description: err ? err : null,
        status: "error",
      });
    }
  };

  const clearCacheHandler = async () => {
    let body = {};
    // body["Type"] = "Hard";
    body["StationId"] = data?.StationId;
    try {
      const response = await executeClearCache({ data: body });
      setToast({
        isOpen: true,
        title: "Request sent successfully",
        status: "success",
      });
    } catch (error) {
      const err = error?.response?.data?.error;
      setToast({
        isOpen: true,
        title: "Error occured while sending request to the charger",
        description: err ? err : null,
        status: "error",
      });
    }
  };
  useEffect(() => {
    if (data?.Status) {
      setChargePointStatus(data?.Status);
    }
    const interVal = setInterval(() => {
      getChargePointDetails();
    }, 5000);
    return () => clearInterval(interVal);
  }, [data?.Status]);
  return (
    <Card px={{ base: 2, md: 4 }} py={{ base: 3, md: 4 }}>
      <div>
        <Flex
          alignItems={{ base: "flex-start", lg: "center" }}
          justifyContent="space-between"
          className="acCharger_main"
          direction={{ base: "column", lg: "row" }}
          flexWrap={{ base: "wrap", md: "wrap", lg: "nowrap" }}
          gap={{ base: 4, lg: 0 }}
        >
          <Box
            className="acCharger_table"
            w={{ base: "100%", lg: "auto" }}
            overflowX="auto"
          >
            <table className="acCharger_table_main">
              <tbody>
                <tr>
                  <td className="acCharger_table_label">Socket URL</td>
                  <td className="acCharger_table_data">
                    {cmsEnv === "staging"
                      ? "ws://" +
                        subDomain +
                        ".cms.staging.urzzaev.com/cms/" +
                        data.StationId
                      : "ws://" +
                        subDomain +
                        ".cms.urzzaev.com/cms/" +
                        data.StationId}
                  </td>
                </tr>
                <tr>
                  <td className="acCharger_table_label">Station ID</td>
                  <td>{data.StationId}</td>
                </tr>
                <tr>
                  <td className="acCharger_table_label">Status</td>
                  <td>
                    <Flex textAlign={"center"} color="white">
                      <Text
                        bg={
                          chargePointStatus == "Online"
                            ? "whatsapp.500"
                            : "red.500"
                        }
                        borderRadius={"5px"}
                        p={1}
                      >
                        {chargePointStatus}
                      </Text>
                    </Flex>
                  </td>
                </tr>
                <tr>
                  <td className="acCharger_table_label">Power</td>
                  <td>{data.MaxElectricPower} kW</td>
                </tr>
                <tr>
                  <td className="acCharger_table_label">Compatible</td>
                  <td>CAR</td>
                </tr>
                <tr>
                  <td className="acCharger_table_label">Last Updated</td>
                  <td>
                    {updatedAt.toLocaleString("en-US", {
                      timeZone: "Asia/Kolkata",
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </td>
                </tr>
                <RoleBasedRender roles={onlyUAdmins}>
                  <tr>
                    <td className="acCharger_table_label">Property Owner</td>
                    <td>
                      <PropertyOwnerDetails station={data} />
                    </td>
                  </tr>
                </RoleBasedRender>
              </tbody>
            </table>
          </Box>
          <Flex
            flexDirection={{
              base: "column",
              sm: "row",
              lg: "column",
              md: "row",
            }}
            wrap={{ base: "wrap", lg: "nowrap", md: "wrap" }}
            mt={{ base: 0, sm: 5, lg: 0 }}
            mx={{ base: 0, sm: 5, lg: 5 }}
            w={{ base: "100%", lg: "auto" }}
            className="acCharger_table_buttons"
          >
            <QrCode value={data?.StationId} />
            <button
              className="acCharger_button restart"
              onClick={resetHandler}
              disabled={!canEdit}
              isLoading={loading}
            >
              <img
                src={restart}
                alt="restart"
                style={{ display: "inline", marginRight: "0.44rem" }}
              />
              <p>Restart</p>
            </button>
            <RoleBasedRender roles={onlyAdmins}>
              <button
                className="acCharger_button edit"
                onClick={() => editHandler(data.ChargingStationId)}
                disabled={!canEdit}
              >
                <img
                  src={edit}
                  alt="edit"
                  style={{ display: "inline", marginRight: "0.44rem" }}
                />
                <p>Edit</p>
              </button>
            </RoleBasedRender>
            <button
              className="acCharger_button qr"
              disabled={!canEdit}
              onClick={clearCacheHandler}
              isLoading={cLoading}
            >
              <img
                src={cache}
                alt="qr"
                style={{
                  display: "inline",
                  marginRight: "0.44rem",
                  // width: "25px",
                }}
              />
              <p>Clear Cache</p>
            </button>
            <RoleBasedRender roles={onlyAdmins}>
              <ChargerConfig stationId={data.StationId} />
            </RoleBasedRender>
            {/* <button
              className="acCharger_button diagnostics"
              // onClick={() => editHandler(data.ChargingStationId)}
              disabled={!canEdit}
            >
              <img
                src={dg}
                alt="diagnostics_icon"
                style={{
                  display: "inline",
                  marginRight: "0.44rem",
                  // width: "20px",
                }}
              />
              <p>Diagnostics</p>
            </button> */}
            <RoleBasedRender roles={onlyUAdmins}>
              <Firmware station={data} />
            </RoleBasedRender>
          </Flex>
        </Flex>

        <ConnectorTabs chargePointId={data.Id} chargePointCode={data.EvseId} />
      </div>
      {updateDrawerState?.isOpen && (
        <UpdateChargePointDrawer
          update={updateHandler}
          chargePointId={data.Id}
        />
      )}
    </Card>
  );
};

export default ChargePoint;
